import { render, staticRenderFns } from "./ThumbsUp.vue?vue&type=template&id=0c04e28a"
import script from "./ThumbsUp.vue?vue&type=script&lang=js"
export * from "./ThumbsUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports